module.exports = __webpack_public_path__ + "static/cube3-def82514fe8e3db5b16f485eba265e1c.svg";